import { render, staticRenderFns } from "./expressFile.vue?vue&type=template&id=71ad0cb7&scoped=true"
import script from "./expressFile.vue?vue&type=script&lang=js"
export * from "./expressFile.vue?vue&type=script&lang=js"
import style0 from "./expressFile.vue?vue&type=style&index=0&id=71ad0cb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad0cb7",
  null
  
)

export default component.exports